import { makeStyles } from '@mui/styles';

import Button from '@classify/react-core-components/Button';

import { scrollToElement } from '@openclassrooms/ui-web/scroll';
import browser from '@openclassrooms/utils/browser';

const useStyles = makeStyles(({ palette }) => ({
  iconWrapper: {
    width: 24,
    height: 40,
  },
  doubleChevronIcon: {
    fill: palette.primary.main,
    '@media (prefers-reduced-motion: no-preference)': {
      animation: '$bounce 6s 5s ease-in-out infinite',
    },
  },
  '@keyframes bounce': {
    '4%': {
      transform: 'translate(0, 10px)',
    },
    '8%': {
      transform: 'translate(0, 4px)',
    },
    '12%': {
      transform: 'translate(0, 10px)',
    },
    '16%, 100%': {
      transform: 'translate(0, 0px)',
    },
  },
}));

const ScrollDownButton = ({ targetElementId, ariaLabel }) => {
  const classes = useStyles();

  const handleClick = () => {
    scrollToElement(browser.document.getElementById(targetElementId));
  };

  return (
    <Button sx={{ padding: 0 }} variant="tertiary" onClick={handleClick} aria-label={ariaLabel}>
      <div className={classes.iconWrapper}>
        <svg
          className={classes.doubleChevronIcon}
          width="24"
          height="33"
          viewBox="0 0 24 33"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 18L12 25L19 18L17.7485 16.7485L12 22.497L6.25152 16.7485L5 18Z" />
          <path d="M5 9L12 16L19 9L17.7485 7.74848L12 13.497L6.25152 7.74848L5 9Z" />
        </svg>
      </div>
    </Button>
  );
};

export default ScrollDownButton;
